module.exports = __webpack_public_path__ + "f37f99ce242a10f5679cdaba54db22f2.png";